import { Helmet } from "react-helmet-async";
import styles from "./dona.module.css";
import { motion } from "framer-motion";
import fon from "../../images/one.jpg";
import { NavLink } from "react-router-dom";

function DonaPage() {
  const textAnimation = {
    hidden: {
      x: -1000,
      opacity: 0,
    },
    visible: (custom: number) => ({
      x: 0,
      opacity: 1,
      transition: { delay: custom * 0.5, duration: 1 },
    }),
  };
  return (
    <motion.div className={styles.main} initial="hidden" whileInView="visible">
      <Helmet>
        <title>Lily-Dance Studio</title>
        <meta name="description" content="Dance and Vocal Classes with Lily" />
        <link rel="canonical" href="https://www.lily-d.com/" />
      </Helmet>
      <div className={styles.boxt}>
        <h1 className={styles.title}>Lily-Dance Studio</h1>
      </div>
      <motion.div className={styles.main} custom={1} variants={textAnimation}>
        <img className={styles.image} src={fon} alt="dance" />
      </motion.div>
      <motion.div className={styles.box} custom={2} variants={textAnimation}>
        <NavLink to="/" style={{ textDecoration: "none" }}>
          <h1 className={styles.title}>to be continued...</h1>
        </NavLink>
      </motion.div>
    </motion.div>
  );
}

export default DonaPage;
